// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jFFgIezjq0OlOCJT{display:flex;flex-direction:column;width:100%;padding:8px 0}.jFFgIezjq0OlOCJT .V1H_2ErRJuwAkrNN .UHfDkpjx6dwmFy7_{display:flex;align-items:center;column-gap:8px;width:100%}.jFFgIezjq0OlOCJT .V1H_2ErRJuwAkrNN .UHfDkpjx6dwmFy7_ .JhxE9RvjYqAbxfnh{display:flex;flex-direction:column}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"goalList": `jFFgIezjq0OlOCJT`,
	"goalListItemContainer": `V1H_2ErRJuwAkrNN`,
	"goalListItem": `UHfDkpjx6dwmFy7_`,
	"goalDetails": `JhxE9RvjYqAbxfnh`
};
export default ___CSS_LOADER_EXPORT___;
